import React from "react";
import { useHistory } from "react-router-dom";
import { Box, Typography, Stack } from "@mui/material";
import LinearBar from "../LinearBar";
import MapLinearBar from "../MapLinearBar";
import { kFormatter } from "../../constants/function";

export default function AnalyticsCard(props, norot) {
  const history = useHistory();
  return (
    <Box
      sx={{
        padding: "10px",
        borderRadius: "5px",
        display: "flex",
        flexDirection: "column",
        // backgroundColor: "#262626",
        backgroundColor: "#090909",
        minWidth: "110px",
        border: "2px solid #2E2E2E",
        justifyContent: "space-between",
        position: "relative",
      }}
      className={"_cp"}
      onClick={() => history.push(`/app/LifetimeCount/${props.type}`)}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        {/* {props.icon} */}
        <img style={{ width: "30px" }} src={props.icon} alt={props.name} />
        <Typography className=" _cp" style={{ fontSize: "20px" }}>
          {props.name}
        </Typography>
      </Stack>
      <Stack
        // textAlign="right"
        sx={{
          display: "flex",
          alignItems: "baseline",
          justifyContent: "end",
          flexDirection: "row",
        }}
      >
        <Typography
          sx={{
            fontSize: "30px",
            fontWeight: "bold",
            color: "#BDBDBD",
            cursor: "pointer",
          }}
        >
          {/* {props.type === "Tips"
            ? kFormatter(props.count) + "USD"
            : kFormatter(props.count)} */}
          {kFormatter(props.count)}
        </Typography>
        {props.type === "Tips" ? (
          <Typography
            sx={{
              fontSize: "20px",
              // fontWeight: "bold",
              color: "#BDBDBD",
              cursor: "pointer",
              marginLeft: "6px",
            }}
          >
            USD
          </Typography>
        ) : null}
      </Stack>
      {/* {props.type === "Views" ? (
        <Stack
          sx={{
            height: "6px",
            width: "100%",
            position: "absolute",
            borderRadius: "3px",
            bottom: "0",
            right: "0",
            transform: "",
          }}
        >
          <MapLinearBar color={"#F48706"} value={`30%`} norot={norot} />
        </Stack>
      ) : null} */}
    </Box>
  );
}
